
export default function filterByScope(event, val) {
  return val === '0' || event.SCOPE.indexOf(val) >= 0;
}



// WEBPACK FOOTER //
// ./src/services/filters/filterByScope.js